/**
 * Splits a strict HEXA color token into SVG `fill` and `fill-opacity` values.
 *
 * @param fillColor A `#RRGGBBAA` color token supplied by a page-owned field theme.
 * @returns A new object containing the RGB fill token and alpha opacity rounded to three decimals.
 * @throws {TypeError} When the supplied token is not strict uppercase or lowercase HEXA.
 */
export function resolveHexaFill(fillColor: string): {
  readonly fill: string;
  readonly fillOpacity: number;
} {
  if (!/^#[\da-fA-F]{8}$/.test(fillColor)) {
    throw new TypeError('Expected fillColor to use the #RRGGBBAA format.');
  }

  const alphaDecimal = Number.parseInt(fillColor.slice(7, 9), 16);

  return {
    fill: fillColor.slice(0, 7),
    fillOpacity: Number((alphaDecimal / 255).toFixed(3)),
  };
}
